import React from 'react';
import { IconProps } from '../types';
const MinecraftIronNugget: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="5" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(186, 200, 218, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(217, 223, 231, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(217, 223, 231, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(242, 242, 242, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(242, 242, 242, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(217, 223, 231, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(162, 176, 190, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(162, 176, 190, 255)" />
<rect x="11" y="7" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(242, 242, 242, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(217, 223, 231, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(217, 223, 231, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(162, 176, 190, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(115, 141, 141, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(115, 141, 141, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(88, 95, 104, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(189, 202, 219, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(186, 200, 218, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(186, 200, 218, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(57, 60, 64, 255)" />
</svg>);
export default MinecraftIronNugget;